import responseHelper from '../../services/ResponseHelper';
import calendarEventService from '../../services/calendarEventService';
import CoreBase from '../../services/engines/CoreBase';

export default class CalendarFetcher extends CoreBase {
    // Class field — overrides CoreBase._name so logError shows correct source
    _name = 'CalendarFetcher';

    /**
     * Fetches all CalEvents for the current user.
     * Translates backend field names to FE field names
     * (description → desc, createdAt → createdOn).
     * @returns {object[]|null} array of raw event objects, or null on failure
     */
    fetch = async () => {
        try {
            const resp = await calendarEventService.getCalendarEvent();
            const code = responseHelper.check(resp, 'fetch', this._name);

            // Fetch failed — log via CoreBase, publishes to ErrorEngine
            if (code < 0) {
                this.logError('fetch', `getCalendarEvent failed — code=${code}`);
                return null;
            }

            // KD8 envelope: resp.data.items holds the array
            const items = resp.data?.items ?? [];
            return items.map(this._mapItem);
        } catch (error) {
            this.logError('fetch', error.message);
            return null;
        }
    };

    // ─── private ──────────────────────────────────────────

    /**
     * Translates a raw backend item to FE field names.
     * posX/posY gaan ongewijzigd door — CalEventObj leidt daar in zijn
     * constructor 1x `.pos` van af (echte positie of fallback), voor zowel
     * dit REST-pad als het SignalR push-pad. Geen aparte mapping hier.
     * @param {object} item - raw item from resp.data.items
     * @returns {object}
     */
    _mapItem = (item) => ({
        ...item,
        desc: item.description ?? null,
        createdOn: item.createdAt ?? 0,
    });
}
